import { csrf_headers, get_token, set_user_details } from '@/router/index.js';

export const navbar_profile_fetch_methods = {
  ensure_profile_token(token) {
    if (token) return true;

    this.$router.push({ name: 'Login' });
    return false;
  },

  async get_user_details() {
    const token = get_token();
    if (!this.ensure_profile_token(token)) return;

    try {
      const response = await fetch(this.current_user_url(), {
        method: 'GET',
        headers: this.profile_get_headers(token),
      });
      await this.apply_user_details_response(response);
    } catch {
      this.$notyf.info('Error fetching user details');
    }
  },

  current_user_url() {
    return `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_current_user/`;
  },

  profile_get_headers(token) {
    return ({
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`,
    });
  },

  async apply_user_details_response(response) {
    if (response.ok) {
      this.apply_user_details((await response.json()).data);
      return;
    }
    this.handle_user_details_error(response);
  },

  apply_user_details(user) {
    this.user = user;
    this.original_user = {
      first_name: this.user.first_name || '',
      last_name: this.user.last_name || '',
      email: (this.user.email || '').toLowerCase(),
    };
    set_user_details(this.user);
    this.set_user_initials();
    this.init_branding();
  },

  set_user_initials() {
    if (!this.user?.first_name || !this.user?.last_name) return;

    this.user_initials = this.user.first_name[0].toUpperCase()
      + this.user.last_name[0].toUpperCase();
  },

  handle_user_details_error(response) {
    if (response.status === 403 || response.status === 401) {
      this.$router.push({ name: 'Login' });
      return;
    }
    this.$notyf.info('Error fetching user details');
  },

  async get_company_profile(company_id) {
    const token = get_token();
    if (!this.ensure_profile_token(token)) return;

    try {
      const response = await fetch(this.company_profile_url(company_id), {
        method: 'GET',
        credentials: 'include',
        headers: this.profile_csrf_headers(token),
      });
      await this.apply_company_profile_response(response);
    } catch {
      this.$notyf.info('Error fetching organization details');
    }
  },

  company_profile_url(company_id) {
    return `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_client_company?company_id=${company_id}`;
  },

  profile_csrf_headers(token) {
    return ({
      ...this.profile_get_headers(token),
      ...csrf_headers(this.csrfToken),
    });
  },

  async apply_company_profile_response(response) {
    if (!response.ok) {
      this.$notyf.info('Error fetching organization details');
      return;
    }

    this.new_company = (await response.json()).data;
    this.original_company = this.company_snapshot();
  },

  snapshot_value(source, key) {
    const value = Reflect.get(source ?? {}, key);
    return [value, ''].find((item) => item !== null && item !== undefined);
  },

  company_snapshot() {
    const company = this.new_company;

    return ({
      company_name: this.snapshot_value(company, 'company_name'),
      registration_number: this.snapshot_value(company, 'registration_number'),
      vat_number: this.snapshot_value(company, 'vat_number'),
      phone_number: this.snapshot_value(company, 'phone_number'),
      address: this.snapshot_value(company, 'address'),
    });
  },

  async get_user_profile(profile_id) {
    const token = get_token();
    if (!this.ensure_profile_token(token)) return;

    try {
      const response = await fetch(this.user_profile_url(profile_id), {
        method: 'GET',
        credentials: 'include',
        headers: this.profile_csrf_headers(token),
      });
      await this.apply_user_profile_response(response);
    } catch {
      this.$notyf.info('Error fetching user profile');
    }
  },

  user_profile_url(profile_id) {
    return `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_user_profile?profile_id=${profile_id}`;
  },

  async apply_user_profile_response(response) {
    if (!response.ok) {
      this.$notyf.info('Error fetching user profile');
      return;
    }

    this.user_profile = (await response.json()).data;
    this.original_profile = this.user_profile_snapshot();
  },

  user_profile_snapshot() {
    const profile = this.user_profile;

    return ({
      phone_number: this.snapshot_value(profile, 'phone_number'),
      address: this.snapshot_value(profile, 'address'),
      id_number: this.snapshot_value(profile, 'id_number'),
      province: this.snapshot_value(profile, 'province'),
      country: this.snapshot_value(profile, 'country'),
      gender: this.snapshot_value(profile, 'gender'),
    });
  },
};
